import { applyMetaData } from './metaUtils'
import { generateJobPostingSchema } from '~/plugins/structuredData/JobPosting'
import { generateItemListShema } from '~/plugins/structuredData/ItemList'
import type { Job } from '~/types'

export interface ViewJobMetaOptions {
  noIndex?: boolean  // Set to true if job is not in job_indexation
}

export function generateViewJobPageMeta(route: { path: string }, jobs?: Job[], brandName?: string, options?: ViewJobMetaOptions) {
  const { noIndex = false } = options || {}
  // Always noindex for non-company viewJob pages (/viewJob/[job])
  // Company viewJob pages (/company/[permalink]/viewJob/[id]) can be indexed if job is in job_indexation
  const isCompanyViewJob = route.path.includes('/company/')
  const shouldIndex = isCompanyViewJob ? !noIndex : false

  if (!jobs || !jobs.length) {
    const schemas = [JSON.stringify(generateItemListShema(menuLinks.b2c))]
    applyMetaData({
      title: 'View Job - employers.io',
      description: 'View job details and apply - employers.io',
      canonical: route.path,
      index: shouldIndex,
      follow: shouldIndex,
      schemas
    })
    return
  }
  const job = jobs[0]
  const canonical = route.path
  const company = brandName || job.company || ''
  const city = job.location?.city || ''
  const state = job.location?.state || ''
  const jobTitle = job.title || ''
  let salaryPart = ''
  if (job.compensation) {
    salaryPart = job.compensation
  } else if (job.estimated_salary?.adjusted_salary) {
    const p25 = job.estimated_salary.adjusted_salary.P25
    const p75 = job.estimated_salary.adjusted_salary.P75
    const hourlyP25 = Math.round(p25 / 2080)
    const hourlyP75 = Math.round(p75 / 2080)
    salaryPart = `$${hourlyP25} - $${hourlyP75}/hour`
  }
  let title = `${company} Jobs in ${city}, ${state}`
  if (salaryPart) {
    title += ` - ${salaryPart}`
  }
  title += ` - ${jobTitle}`
  const description = `${company} is hiring! ${job.title} job in ${job.location.city} - Apply now.`
  const jobSchema = generateJobPostingSchema(job, canonical)
  const menuSchema = generateItemListShema(menuLinks.b2c)
  const schemas = [JSON.stringify(jobSchema), JSON.stringify(menuSchema)]
  applyMetaData({
    title,
    description,
    canonical,
    index: shouldIndex,
    follow: shouldIndex,
    schemas
  })
  return {
    title,
    description,
    canonical,
    index: shouldIndex,
    follow: shouldIndex,
    schemas
  }
}
